import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ConnectorsConsole } from '@/features/admin/connectors/ConnectorsConsole';
import { isConnectorsTab, type ConnectorsTab } from '@/features/admin/connectors/connectorVocabulary';

interface ConnectorsSearch {
  /** La scheda aperta; assente = «Connettori». Nell'URL perché F5 la ritrovi e un link la porti. */
  tab?: ConnectorsTab;
}

export const Route = createFileRoute('/_app/admin/connectors')({
  validateSearch: (s: Record<string, unknown>): ConnectorsSearch => ({
    tab: isConnectorsTab(s.tab) && s.tab !== 'connectors' ? s.tab : undefined,
  }),
  component: ConnectorsRoute,
});

/** Connettori verso i gestionali: stato, giri, log e comandi. Il perché in `ConnectorsConsole`. */
function ConnectorsRoute() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate();
  return (
    <ConnectorsConsole
      tab={tab ?? 'connectors'}
      onTabChange={(next) => void navigate({
        to: '/admin/connectors',
        search: { tab: next === 'connectors' ? undefined : next },
        replace: true,
      })}
    />
  );
}
